import stateApi from '@/api/state.api'

export const stateService = (function () {
  'use strict'


  /**
   * Devuelve todos los estados para el selector de estados en el ABM de empresas
   */
  async function findAllForSelector() {
    try {
      const response = await stateApi.findAllForSelector()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve todos los estados para el selector de estados en el ABM de empresas, aplicables a una empresa
   */
  async function findAllForSelectorByEnterprise(enterpriseId) {
    try {
      const response = await stateApi.findAllForSelector(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  async function getTypesByKeys(keys) {
    try {
      const response = await stateApi.getTypesByKeys(keys)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Datos para la tabla del ABM de tipos de estados
   * @param {*} pageSize
   * @param {*} pageNumber
   */
  // eslint-disable-next-line no-unused-vars
  async function findAllStateType(pageSize, pageNumber) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await stateApi.findAll(pageSize, pageNumber)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await stateApi.findAllStateType(undefined, undefined)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Total de tipos de estados de la colección
   */
  async function getStateTypeTotal() {
    try {
      const response = await stateApi.getStateTypeTotal()
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve los datos de un tipo de estado a partir de su id, para la actualización
   * @param {*} stateTypeId
   */
  async function findOneStateType (stateTypeId) {
    try {
      const response = await stateApi.findOneStateType(stateTypeId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para eliminar un tipo de estado
   * Primero se valida de que no exista una relación con una cosa en la collection de estados
   * @param {*} id
   */
  async function deleteOneStateType(id) {
    try {
        const response = await stateApi.deleteOneStateType(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Para eliminación múltiple
   * Por cada estado, se hace la misma validación que cuando se elimina un único estado
   */
  async function deleteManyStateType(ids) {
    try {
        const response = await stateApi.deleteManyStateType(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }


  /**
   * Crea un nuevo tipo de estado en la collection
   * @param {*} stateType
   */
  async function createStateType(stateType) {
    const response = await stateApi.createStateType(stateType)
    return response.data
  }

  /**
   * Actualiza un tipo de estado existente en la collection
   * @param {*} stateType
   */
  async function updateStateType(stateType) {
    const response = await stateApi.updateStateType(stateType)
    return response.data
  }

  /**
   * Validación de una traducción del nombre
   * @param {*} locale 
   * @param {*} translation 
   * @param {*} id 
   */
  async function validateTranslation(locale, translation, id) {
    try {
      if (translation) {
        const response = await stateApi.validateTranslation(locale, translation, id)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  return {
    findAllForSelector,
    getStateTypeTotal,
    findAllStateType,
    findOneStateType,
    deleteOneStateType,
    deleteManyStateType,
    createStateType,
    updateStateType,
    validateTranslation,
    findAllForSelectorByEnterprise,
    getTypesByKeys
  }
})()